import { useEffect, useImperativeHandle, useState } from 'react';
import { TextArea } from "@progress/kendo-react-inputs";
import { isNullOrEmpty } from '../../../../components/helpers/ObjectHelpers';
import { PilotAssignmentCommands } from '../../services/DispatcherActions';
import { Card } from '../../../../components/layout/card/Card';
import { useHasEditableChanged } from '../hooks/usePilotAssignmentStore';

export const RemarkCard = (
    {
        ref,
        onPilotAssignmentChanged,
        assignmentService
    }) => {

    useImperativeHandle(ref, () => ({
        onPilotageChanged() {
            initializeAsync();
        }
    }));

    const [isEditable, setIsEditable] = useState(false);
    const [remark, setRemark] = useState("");
    const [isDirty, setIsDirty] = useState(false);

    const isEditableChanged = useHasEditableChanged();

    useEffect(() => {
        initializeAsync()
    }, [])

    useEffect(() => {
        if(!isEditableChanged) return;
        initializeAsync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditableChanged]);

    return (
        <Card
            title="Losens kommentar"
            clipboardText={remark}
            isDirty={isDirty}>
            <TextArea
                disabled={!isEditable}
                value={remark}
                rows={4}
                onChange={onRemarkChangeAsync}
                className="font-size-lg"
            />
        </Card>
    )

    async function initializeAsync() {
        const pilotAssignment = assignmentService.assignment;
        setIsEditable(assignmentService.isEditable);

        if (!isNullOrEmpty(pilotAssignment.remark)) {
            setRemark(pilotAssignment.remark)
        }

        setIsDirty(assignmentService.hasCommandType(PilotAssignmentCommands.PilotRemark));
    }

    async function onRemarkChangeAsync(e) {

        if (!isEditable) return;

        setIsDirty(true);
        setRemark(e.value);

        await assignmentService.onRemarkAsync(e.value);

        onPilotAssignmentChanged();
    }
}
